import { NavLink } from "react-router-dom";
import Breadcumbs from "../../components/Breadcumbs";
import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";

import ConectUs from "../../components/ConectUs";

import BlockLeftImage from "../../components/BlockLeftImage";

import Block3Columns from "../../components/Block3Columns";

import BlockRightImage from "../../components/BlockRightImage";

function CarreraNegociosMetodologia() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div className="margin ">
            <Breadcumbs
              content={
                <>
                  <NavLink to="/carrera-turismo-gastronomia">
                    Carrera de Negocios Turísticos y Gastronómicos
                  </NavLink>
                  <span class="material-icons">chevron_right</span>
                  <NavLink to="/metodologia-turismo-gastromonia">
                    Metodología
                  </NavLink>
                </>
              }
            ></Breadcumbs>

            <div className="  layout8">
              {" "}
              <div
                dangerouslySetInnerHTML={{
                  __html: item.field_texto_portada,
                }}
              />
            </div>
            <img src={item.field_portada} alt="utpl"></img>

            <div className="padding lightbluebg">
              <div>
                <div
                  className="layout6"
                  dangerouslySetInnerHTML={{
                    __html: item.field_bloque5,
                  }}
                />
                <div className="layout8">
                  <center>
                    <p className="iconsize20">🔏</p>
                    <h3>Certificaciones</h3>
                  </center>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque6,
                    }}
                  />
                </div>
              </div>
            </div>

            <BlockRightImage
              src={item.field_imagen1}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque1,
                    }}
                  />
                </>
              }
            ></BlockRightImage>
            <BlockLeftImage
              src={item.field_imagen2}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque2,
                    }}
                  />
                </>
              }
            ></BlockLeftImage>

            <BlockRightImage
              src={item.field_imagen3}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque3,
                    }}
                  />
                </>
              }
            ></BlockRightImage>
            <BlockLeftImage
              src={item.field_imagen4}
              content={
                <>
                  {" "}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: item.field_bloque4,
                    }}
                  />
                </>
              }
            >
              {" "}
            </BlockLeftImage>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/metodologia-negocios.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>

      <ConectUs
        lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes en línea y a distancia."
        instagram="https://www.instagram.com/utplenlinea/"
        facebook="https://www.facebook.com/utplenlinea/"
        tiktok="https://www.tiktok.com/@utplenlinea"
      ></ConectUs>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default CarreraNegociosMetodologia;
